import { render, staticRenderFns } from "./CenterContent.vue?vue&type=template&id=becc67ac&scoped=true&"
import script from "./CenterContent.vue?vue&type=script&lang=js&"
export * from "./CenterContent.vue?vue&type=script&lang=js&"
import style0 from "./CenterContent.vue?vue&type=style&index=0&id=becc67ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becc67ac",
  null
  
)

export default component.exports